import React from 'react';
import c from 'classnames';
import { useTranslation } from 'react-i18next';
import { PapiUser } from '@wix/da-papi-types';
import UserLink from '../../../User/Link';
import { type BasicUserLinkProps } from '../../../User/_partials/BasicUserLink';
import AuthorWatchButton from '../../../Button/AuthorWatchButton';
import s from './Author.scss';

export interface Props
  extends Pick<BasicUserLinkProps, 'linkTo' | 'anchor' | 'deviationIdSeed'> {
  author?: PapiUser;
  isOwner?: boolean;
  withByline?: boolean;
  className?: string;
}

const Author: React.FC<Props> = ({
  author,
  isOwner,
  withByline = true,
  className,
  linkTo,
  deviationIdSeed,
  anchor,
}) => {
  const { t } = useTranslation();

  if (!author) {
    return null;
  }

  return (
    <div className={c(s['root'], className)}>
      {withByline && (
        <div className={s['by']}>{t('deviation.details.by')} </div>
      )}
      <UserLink
        className={s['username']}
        usernameClassName={s['username-inner']}
        withTooltip
        user={author}
        linkTo={linkTo}
        deviationIdSeed={deviationIdSeed}
        anchor={anchor}
      />
      {!isOwner && <AuthorWatchButton author={author} />}
    </div>
  );
};
Author.displayName = 'Author';

export default Author;
